/**
 * 파일명 : pjt0102m.tsx
 * 설명 : 프로젝트 등록 화면
 * 수정내역
 ************************************************
 * Version	   수정일자			수정자	    수정내용      
 ************************************************
 * 1.0		2023-03-02			            최초작성
 * 1.1      2023-03-31         유승현       입력컬럼추가
 * 1.2      2024-01-15         김시현       필수조건 및 PM항목 수정 
 * 1.3      2024-02-01         김승연       메일발송 기능 추가
 * 1.4      2024-03-13         이경원       '고객사명' 에 사업장 팝업 선택으로 등록하기
 * 1.5      2024-03-19         이경원       계약공수&수행공수 M/M input박스 옆으로 붙이기
 *                                         , 금액 0으로 시작 못하게 제한 

 **/

/************************************************
 * Import 영역  
 ************************************************/
/* React */
import React from 'react';
import locale from 'antd/lib/locale/ko_KR';

/* Reducer */
import { useAppSelector, useAppDispatch } from '../../../redux/hooks';
import { Pjt0102mAction } from '../../../redux/slice/pjt/pjt0102m_slice';
import { IComCdItemState, IDeptCdItemState, IPjtInfoItemState, IUserItemState } from '../../../redux/models/pjt/pjt0102m_model';

/* AntD */
import { Layout, Row, Col, Space, Descriptions, Input, DatePicker, Button, Typography, ConfigProvider, Select } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

/* 업무 */
import * as commonProxy from 'libs/CommonProxy';
import * as common from 'libs/common';
import * as commonDate from 'libs/commonDate';
import dayjs from 'dayjs';

const Pjt0102m = (props:any) => {
    /************************************************
     * 화면 초기화 영역  
     ************************************************/
    /**
     * 기능 : State / Reducer 선언
     * param : 
     */
    const dispatch = useAppDispatch();
    const pjtInfoItem    = useAppSelector((state) => state.Pjt0102m.pjtInfoItem);
    const userList       = useAppSelector((state) => state.Pjt0102m.userList);
    const cmbDeptUsrList = useAppSelector((state) => state.Pjt0102m.cmbDeptUsrList);
    const cmbOfcUsrList  = useAppSelector((state) => state.Pjt0102m.cmbOfcUsrList);
    const cmbList021     = useAppSelector((state) => state.Pjt0102m.cmbList021);
    const cmbList022     = useAppSelector((state) => state.Pjt0102m.cmbList022);
    const cmbList023     = useAppSelector((state) => state.Pjt0102m.cmbList023);
    const cmbList024     = useAppSelector((state) => state.Pjt0102m.cmbList024);
    const cmbList025     = useAppSelector((state) => state.Pjt0102m.cmbList025);
    const [isEditMode, setIsEditMode] = React.useState(false);

    /** Render 변수 선언영역 **/
    const componentRef = React.useRef(null);

    /* AntD */
    const { Content } = Layout;
    const { RangePicker } = DatePicker;
    const { TextArea } = Input;
    const { Text } = Typography;

    /**
     * 기능 : componentDidMount
     * 설명 : 화면 최초 로드시에 필요한 기능을 구현한다.
     * param : 
     * return : None
     **/
    React.useEffect(() => {
        fn_User();           // 사용자전체조회
        fnCmb021();          // 개발유형코드조회
        fnCmb022();          // 사업구분코드조회
        fnCmb023();          // 프로젝트성격코드조회
        fn_DeptCds();        // 부서조회

        if (!common.isEmptyString(props.pjCd)) {
            alert(props.pjCd)
            /* 변수선언 `및 셋팅 영역 */
            // 입력파라미터
            const requestData = {
                pjCd: props.pjCd
            };

            /* 트렌젝션 호출 및 결과 셋팅 */
            commonProxy.callAsyncSvc(requestData, {
                txCd: 'TRPJTR0003',
                success: (responseData:any) => {
                    console.log(responseData)
                    dispatch(Pjt0102mAction.setPjtInfoItem(responseData.pjtInfo));
                },
            });
        } else {
            alert(2)
            dispatch(Pjt0102mAction.setPjtInfoItem({ ...pjtInfoItem, pmEmpNo: common.getEmpNo() }));
        }

        return () => {
            dispatch(Pjt0102mAction.initState());
        }
    }, []);


    /**
     * 기능 : fn_User
     * 설명 : 사용자 콤보박스 데이터 조회
     * param : 
     * return : None
     **/
     const fn_User = () => {
        /* 변수선언 및 셋팅 영역 */
        // 입력파라미터
        const requestData = {
            userStCd: 'A'
        };

        /* 트렌젝션 호출 및 결과 셋팅 */
        commonProxy.callAsyncSvc(requestData, {
            txCd: 'TRUSRR0003',
            success: (responseData:any) => {
                // 사용자목록 이름순으로 정렬
                responseData.userList.sort((a:IUserItemState, b:IUserItemState) => (a.userNm > b.userNm) ? 1 : -1)
                dispatch(Pjt0102mAction.setUserList(responseData.userList));
            },
        });
    };

    const userOptions = React.useCallback(() => {
        const arrUserOptions:IUserItemState[] = [];
        userList.forEach((item:IUserItemState) => {
            arrUserOptions.push({
                label: item.userNm + ': ' + item.userId,
                value: item.empNo
            });
        });

        return arrUserOptions;
    }, [userList]);
    
    /************************************************
     * 공통코드조회 함수 영역
     ************************************************/
    /**
     * 기능 : fnCmb021
     * 설명 : 개발유형코드 조회
     * param : 
     * return : None
     **/
    const fnCmb021 = () => {
        const option = {
            useYn: 'Y',
            callback: (datas:IComCdItemState[]) => {
                let arrOptions:IComCdItemState[] = [];

                datas.forEach((item:IComCdItemState) => {
                    arrOptions.push({
                        label: item.cdNm,
                        value: item.cd,
                    });
                });

                dispatch(Pjt0102mAction.setCmbList021(arrOptions));
            }

        };
        common.getComCodeList('026', option);
    };

    /**
     * 기능 : fnCmb022
     * 설명 : 사업구분코드 조회
     * param : 
     * return : None
     **/
    const fnCmb022 = () => {
        const option = {
            useYn: 'Y',
            callback: (datas:IComCdItemState[]) => {
                let arrOptions:IComCdItemState[] = [];

                datas.forEach((item:IComCdItemState) => {
                    arrOptions.push({
                        label: item.cdNm,
                        value: item.cd,
                    });
                });

                dispatch(Pjt0102mAction.setCmbList022(arrOptions));
            }

        };
        common.getComCodeList('027', option);
    };

    /**
     * 기능 : fnCmb023
     * 설명 : 프로젝트성격코드 조회
     * param : 
     * return : None
     **/
    const fnCmb023 = () => {
        const option = {
            useYn: 'Y',
            callback: (datas:IComCdItemState[]) => {
                let arrOptions:IComCdItemState[] = [];

                datas.forEach((item:IComCdItemState) => {
                    arrOptions.push({
                        label: item.cdNm,
                        value: item.cd,
                    });
                });

                dispatch(Pjt0102mAction.setCmbList023(arrOptions));
            }

        };
        common.getComCodeList('028', option);
    };

    /**
     * 기능 : fn_DeptCds
     * 설명 : 부서코드 콤보박스 데이터 조회
     * param : 
     * return : None
     **/
     const fn_DeptCds = () => {
        /* 변수선언 및 셋팅 영역 */
        // 입력파라미터
        const requestData = {
            deptStCd: 'A'
        };

        /* 트렌젝션 호출 및 결과 셋팅 */
        commonProxy.callAsyncSvc(requestData, {
            txCd: 'TRCOMR0005',
            success: (responseData:any) => {
                let arrOptions:IDeptCdItemState[] = [];
                let datas:IDeptCdItemState[] = responseData.deptItems;
                datas = datas.filter((s:IDeptCdItemState) => s.deptLvlCd === '2' || s.deptLvlCd === '3');

                datas.forEach((item:IDeptCdItemState) => {
                    arrOptions.push({
                        label: item.deptNm,
                        value: item.deptCd,
                    });
                });
                dispatch(Pjt0102mAction.setCmbList024(arrOptions));

                arrOptions = [];
                datas = responseData.deptItems;
                datas = datas.filter((s:IDeptCdItemState) => s.deptLvlCd === '4');

                datas.forEach((item:IDeptCdItemState) => {
                    arrOptions.push({
                        label: item.deptNm,
                        value: item.deptCd,
                    });
                });
                dispatch(Pjt0102mAction.setCmbList025(arrOptions));
            },
        });
    };

    /************************************************
     * 이벤트 함수 영역
     ************************************************/
    /**
     * 기능 : 등록/수정/삭제버튼 클릭 이벤트
     * 설명 : 등록/수정/삭제
     * param : 
     * return : 
     */
    const fn_Treat = (delYn:string) => {
        /* 변수선언 및 셋팅 영역 */
        // 입력파라미터
        // Decimal 타입 파싱하기 위해 데이터 편집
        let sCtrManMonth  = pjtInfoItem.ctrManMonth.toString().replaceAll(',', '');          // 계약공수
        let sTotAmntAmt   = pjtInfoItem.totAmntAmt.toString().replaceAll(',', '');           // 총계약금액(부가세제외)
        let sPjConsAmt    = pjtInfoItem.pjConsAmt.toString().replaceAll(',', '');            // 컨설팅비용
        let sPjDevAmt     = pjtInfoItem.pjDevAmt.toString().replaceAll(',', '');             // 개발지용
        let sPjHwAmt      = pjtInfoItem.pjHwAmt.toString().replaceAll(',', '');              // H/W비용
        let sPjSwAmt      = pjtInfoItem.pjSwAmt.toString().replaceAll(',', '');              // S/W비용
        let sPjEtcAmt     = pjtInfoItem.pjEtcAmt.toString().replaceAll(',', '');             // 기타비용
        let sPrcsManMonth = pjtInfoItem.prcsManMonth.toString().replaceAll(',', '');         // 수행공수

        // 입력파라미터
        const requestData = {
            ...pjtInfoItem,
            ctrManMonth: sCtrManMonth,
            totAmntAmt: sTotAmntAmt,
            pjConsAmt: sPjConsAmt,
            pjDevAmt: sPjDevAmt,
            pjHwAmt: sPjHwAmt,
            pjSwAmt: sPjSwAmt,
            pjEtcAmt: sPjEtcAmt,
            prcsManMonth: sPrcsManMonth,
            delYn: delYn,
        };

        /* 트렌젝션 호출 및 결과 셋팅 */
        commonProxy.callAsyncSvc(requestData, {
            txCd: 'TRPJTS0002',
            success: (responseData:any) => {
                setIsEditMode(false);
                dispatch(Pjt0102mAction.setPjtInfoItem(responseData.pjtInfo));
                const param = {
                    title : '위드정보 확인',
                    contents: '정상적으로 처리되었습니다.',
                    accept : () => {
                        if (delYn === 'Y') {
                            fn_Reset();
                        }
                    }
                };

                common.openAlert(param);
            },
        });
    };

    /**
     * 기능 : 초기화 함수
     * param : 
     **/
    const fn_Reset = () => {
        dispatch(Pjt0102mAction.initState());
    };

    /**
     * 기능 : 검색 입력값 변경 이벤트
     * 설명 : 입력컴포넌트
     * param : 
     * return : None
     */
    const inputOnChange = React.useCallback((e:any) => {
        const newPjtItem = {...pjtInfoItem, [e.currentTarget.name] : e.currentTarget.value};
        dispatch(Pjt0102mAction.setPjtInfoItem(newPjtItem));
    }, [pjtInfoItem]);

    /**
     * 기능 : Number 입력값 변경 이벤트
     * 설명 : Decimal 타입 적합성 체크
     * param : 
     * return : None
     */
    const inputNumChange = React.useCallback((e:any) => {
        let tempIn = e.currentTarget.value.toString().replaceAll(',', '');

        // 숫자 0으로시작 막기 
        if(/(^0+)/.test(tempIn)){
            tempIn = tempIn.replace(/(^0+)/, ''); 
        }
        
        if ((/^\d*\.?\d{0,2}$/.test(tempIn) || tempIn === '') && !isNaN(tempIn)) {
            let maxLen = e.currentTarget.maxLength;
            let difLen = maxLen > 20 ? 8 : 7;

            let splitVal = tempIn.toString().split('.');
            // 3자리마다 , 표시
            splitVal[0] = splitVal[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

            // . 포함일 경우
            if (splitVal[1] !== undefined) {
                let front = splitVal[0].replaceAll(',', '');

                // maxLen보다 큰경우 return
                if (front.length > maxLen - difLen) return false;
                if (front === '') e.currentTarget.value = 0.0 + Number(tempIn);

                // split해서 .이 없기 때문에 따로 추가해줌
                tempIn = splitVal[0] + '.' + splitVal[1];

                // . 가 없는 경우 소수점 및 , 제외한 길이까지 입력가능
            } else if (splitVal[1] === undefined && tempIn.length > maxLen - difLen) {
                return false;
            } else {
                tempIn = splitVal[0];
            }

            e.currentTarget.value = tempIn;
            const newPjtItem = {...pjtInfoItem, [e.currentTarget.name] : e.currentTarget.value};
            dispatch(Pjt0102mAction.setPjtInfoItem(newPjtItem));
        }
    }, [pjtInfoItem]);

    /**
     *  기능 : RangePicker 데이터 변경
     *  설명 : RangePicker 데이터 변경값을 받는다
     *  param :
     *  return : None
     */
    const calendar_onChange = (_:any, dateStrings:any) => {
        const startDate = dateStrings[0].split('-').join('');
        const endDate   = dateStrings[1].split('-').join('');

        dispatch(Pjt0102mAction.setPjtInfoItem({ ...pjtInfoItem, pjStartDt : startDate, pjEndDt : endDate }));
    };

    /**
     *  기능 : 프로젝트계약일자 데이터 변경
     *  설명 : 프로젝트계약일자 데이터 변경값을 받는다
     *  param :
     *  return : None
     */
    const ctrCalendar_onChange = (datas:any, dateStrings:any) => {
        const startDate = dateStrings[0].split('-').join('');
        const endDate   = dateStrings[1].split('-').join('');

        dispatch(Pjt0102mAction.setPjtInfoItem({ ...pjtInfoItem, pjCtrStdt : startDate, pjCtrEndt : endDate }));
    };

    /**
     *  기능 : 오픈예정일자 데이터 변경
     *  설명 : 오픈예정일자 데이터 변경값을 받는다
     *  param :
     *  return : None
     */
    const openCalendar_onChange = (_:any, dateStrings:any) => {
        dispatch(Pjt0102mAction.setPjtInfoItem({ ...pjtInfoItem, expctOpenDt : dateStrings }));
    };

    /**
     *  기능 : 사용자 콤보 변경
     *  설명 : 사용자 콤보 데이터 변경값을 받는다
     *  param :
     *  return : None
     */
    const userSelect = (inputValue:string) => {
        dispatch(Pjt0102mAction.setPjtInfoItem({ ...pjtInfoItem, pmEmpNo :inputValue }));
    };

    /**
     *  기능 : 프로젝트 종료여부 콤보 변경
     *  설명 : 프로젝트 종료여부 콤보 데이터 변경값을 받는다
     *  param :
     *  return : None
     */
    const endYn_onChange = (inputValue:string) => {
        dispatch(Pjt0102mAction.setPjtInfoItem({ ...pjtInfoItem, endYn :inputValue }));
    }

    /**
     *  기능 : 원격지여부 콤보 변경
     *  설명 : 원격지여부 콤보 데이터 변경값을 받는다
     *  param :
     *  return : None
     */
    const rmtYn_onChange = (inputValue:string) => {
        dispatch(Pjt0102mAction.setPjtInfoItem({ ...pjtInfoItem, remoteYn :inputValue }));
    }

    /**
     *  기능 : 개발유형 콤보 변경
     *  설명 : 개발유형 콤보 데이터 변경값을 받는다
     *  param :
     *  return : None
     */
    const pjDevTypeCd_onChange = (inputValue:string) => {
        dispatch(Pjt0102mAction.setPjtInfoItem({ ...pjtInfoItem, pjDevTypeCd :inputValue }));
    }

    /**
     *  기능 : 사업구분 콤보 변경
     *  설명 : 사업구분 콤보 데이터 변경값을 받는다
     *  param :
     *  return : None
     */
    const workDcd_onChange = (inputValue:string) => {
        dispatch(Pjt0102mAction.setPjtInfoItem({ ...pjtInfoItem, workDcd :inputValue }));
    }

    /**
     *  기능 : 프로젝트성격코드 콤보 변경
     *  설명 : 프로젝트성격코드 콤보 데이터 변경값을 받는다
     *  param :
     *  return : None
     */
    const pjTypeCd_onChange = (inputValue:string) => {
        dispatch(Pjt0102mAction.setPjtInfoItem({ ...pjtInfoItem, pjTypeCd :inputValue }));
    }

    /**
     *  기능 : 프로젝트관리부서 콤보 변경
     *  설명 : 프로젝트관리부서 콤보 데이터 변경값을 받는다
     *  param :
     *  return : None
     */
    const pjAmnDeptCd_onChange = (inputValue:string) => {
        dispatch(Pjt0102mAction.setPjtInfoItem({ ...pjtInfoItem, pjAmnDeptCd : inputValue, pjAmnDeptEmpNo : '' }));
    }
    React.useEffect(() => {
        /* 변수선언 및 셋팅 영역 */
        // 입력파라미터
        const requestData = {
            userStCd: 'A',
            deptCd: pjtInfoItem.pjAmnDeptCd
        };

        /* 트렌젝션 호출 및 결과 셋팅 */
        commonProxy.callAsyncSvc(requestData, {
            txCd: 'TRUSRR0003',
            success: (responseData:any) => {
                // 사용자목록 이름순으로 정렬
                responseData.userList.sort((a:IUserItemState, b:IUserItemState) => (a.userNm > b.userNm) ? 1 : -1);

                const arrUserOptions:IUserItemState[] = [];

                if (responseData.userList && responseData.userList.length > 0) {
                    responseData.userList.forEach((item:IUserItemState) => {
                        arrUserOptions.push({
                            label: item.userNm + ': ' + item.userId,
                            value: item.empNo
                        });
                    });
                    dispatch(Pjt0102mAction.setCmbDeptUsrList(arrUserOptions));
                } else {
                    dispatch(Pjt0102mAction.setCmbDeptUsrList(userOptions()));
                }
            },
        });
    }, [pjtInfoItem.pjAmnDeptCd]);

    /**
     *  기능 : 프로젝트관리실 콤보 변경
     *  설명 : 프로젝트관리실 콤보 데이터 변경값을 받는다
     *  param :
     *  return : None
     */
    const pjAmnOfcDeptCd_onChange = (inputValue:string) => {
        dispatch(Pjt0102mAction.setPjtInfoItem({ ...pjtInfoItem, pjAmnOfcDeptCd : inputValue, pjAmnOfcEmpNo : '' }));
    }
    React.useEffect(() => {
        /* 변수선언 및 셋팅 영역 */
        // 입력파라미터
        const requestData = {
            userStCd: 'A',
            deptCd: pjtInfoItem.pjAmnOfcDeptCd
        };

        /* 트렌젝션 호출 및 결과 셋팅 */
        commonProxy.callAsyncSvc(requestData, {
            txCd: 'TRUSRR0003',
            success: (responseData:any) => {
                // 사용자목록 이름순으로 정렬
                responseData.userList.sort((a:IUserItemState, b:IUserItemState) => (a.userNm > b.userNm) ? 1 : -1)

                const arrUserOptions:IUserItemState[] = [];

                if (responseData.userList && responseData.userList.length > 0) {
                    responseData.userList.forEach((item:IUserItemState) => {
                        arrUserOptions.push({
                            label: item.userNm + ': ' + item.userId,
                            value: item.empNo
                        });
                    });
                    dispatch(Pjt0102mAction.setCmbOfcUsrList(arrUserOptions));
                } else {
                    dispatch(Pjt0102mAction.setCmbOfcUsrList(userOptions()));
                }
            },
        });
    }, [pjtInfoItem.pjAmnOfcDeptCd]);

    /**
     *  기능 : 프로젝트관리부서장 콤보 변경
     *  설명 : 프로젝트관리부서장 콤보 데이터 변경값을 받는다
     *  param :
     *  return : None
     */
    const pjAmnDeptUserId_onChange = (inputValue:string) => {
        dispatch(Pjt0102mAction.setPjtInfoItem({ ...pjtInfoItem, pjAmnDeptEmpNo :inputValue }));
    }

    /**
     *  기능 : 프로젝트관리실장 콤보 변경
     *  설명 : 프로젝트관리실장 콤보 데이터 변경값을 받는다
     *  param :
     *  return : None
     */
    const pjAmnOfcUserId_onChange = (inputValue:string) => {
        dispatch(Pjt0102mAction.setPjtInfoItem({ ...pjtInfoItem, pjAmnOfcEmpNo :inputValue }));
    }


    /**
     * 기능 : onClick 이벤트 선언
     * param : 
     */
    const onClick = async (e:any) => {
        const buttonName = e.currentTarget.name;
        switch (buttonName) {
            case 'btnreset': {
                fn_Reset();
                break;
            }

            case 'btnList': {
                const param = {
                    menuId : 'MPJT2023002',
                    props : {
                    }
                };
                common.openPage(param);
                break;
            }

            case 'btnDelete': {
                const param = {
                    title : '위드정보 확인',
                    contents: '삭제 하시겠습니까?',
                    accept: () => {
                        fn_Treat('Y');
                    }
                };
                common.openConfirm(param);
                break;
            }

            case 'btnSave': {
                let colArr = Object.keys(pjtInfoItem);
                let msg:string;
                for (let i = 0; i < colArr.length; i++) {
                    let colId = colArr[i];                              // pjtInfo 컬럼Id
                    let obj:any = document.getElementById(colId);       // 컬럼Id가 name 으로된 태그
                    let chkVal;                                         // 체크할 태그의 value
                    let chkNm;                                          // pjtInfo 컬럼명
                    let flag = false;

                    if (!obj) obj = document.getElementsByName(colId)[0];  // 컬럼Id가 name 으로된 태그
                    if (!obj) continue;

                    // Input
                    if (!common.isEmptyString(obj.dataset.dirName)) {
                        chkVal = obj.value;
                        chkNm = obj.dataset.dirName;
                        flag = true;
                    }
                    else {
                        // Select
                        const selectElement = obj.closest(".ant-select");
                        if (selectElement) {
                            if (!common.isEmptyString(selectElement.dataset.dirName)) {
                                const key:string = colId;
                                chkVal = pjtInfoItem[key as keyof IPjtInfoItemState];
                                chkNm  = selectElement.dataset.dirName;
                                flag   = true;
                            }
                        }
                    }
                    msg = chkNm + '을 입력하세요.';

                    // 입력값이 없을 경우 Alert 후 return
                    if (flag && (common.isEmptyString(chkVal))) {
                        const param = {
                            title : '위드정보 확인',
                            contents: msg,
                            accept: () => {
                                if (!common.isEmptyString(obj.dataset.dirName)) {
                                    setTimeout(() => {
                                        obj.focus();
                                    }, 300);
                                } else {
                                    const selectElement = obj.closest(".ant-select");
                                    if (selectElement) {
                                        const selector = selectElement.querySelector(".ant-select-selector") as HTMLElement;
                                        if (!common.isEmptyString(selectElement.dataset.dirName)) {
                                            setTimeout(() => {
                                                if (selector) selector.click();
                                            }, 300);
                                        }
                                    }
                                }
                            }
                        };
                        common.openInfo(param);
                        return false;
                    }
                }

                const param = {
                    title : '위드정보 확인',
                    contents: '등록 하시겠습니까?',
                    accept: () => {
                        fn_Treat('N');
                    }
                };
                common.openConfirm(param);
                break;
            }

            case 'btnSrchCusNm': {
                const params:any = {};
                params.title = '고객사검색';
                params.popupId = 'hom0201p';
                params.accept = (data:any) => {
                    dispatch(Pjt0102mAction.setPjtInfoItem({ ...pjtInfoItem, cusNm : data.cusNm, companyInstCd: data.companyInstCd, companyId: data.companyId }));
                };
                params.width = 750;
                params.props = { trDsc : '02' };
                common.openPopup(params);
                break;
            }


            default:
        }
    };

    /**
     *  기능 : 프로젝트 관리자 메일 발송
     *  설명 : 프로젝트 관리자에게 프로젝트 상세내용 변경 메일을 발송한다. 
     *  param :
     *  return : None                                                                                                                  
     */
    const sendEmailToPm = () => {
        /* 필수체크 */
        if(common.isEmptyString(pjtInfoItem.pjNm)){
            const param = {
                title : '위드정보 확인',
                contents: '프로젝트명은 필수입력 항목입니다.',
            };

            common.openInfo(param);
            return
        }

        /* 변수선언 `및 셋팅 영역 */
        // 입력파라미터
        const requestData = {
            pjNm : pjtInfoItem.pjNm,       // 프로젝트명
            pmEmpNo : pjtInfoItem.pmEmpNo  // 프로젝트 관리자
        };

        /* 트렌젝션 호출 및 결과 셋팅 */
        commonProxy.callAsyncSvc(requestData, {
            txCd: 'TRPJTR0009',
            success: (_:any) => {
                const param = {
                    title : '위드정보 확인',
                    contents: '메일 요청이 완료되었습니다.',
                };

                common.openAlert(param);
            },
        });
    };
    
    return (
        /* 화면 디자인 영역 */
        <Layout>
            <Content>
                <div ref={componentRef} style={{ marginLeft: 20, marginRight: 20 }}>
                    <Row>
                        <Col style={{ width: '100%' }}>
                            <img className='title-icon' alt='' />
                            <Text strong>프로젝트정보</Text><Text style={{color: 'blue'}}>(※ PM 및 관리자만 등록 가능합니다.)</Text>
                            <Descriptions bordered column={1} size='small' >
                                <Descriptions.Item label='프로젝트코드' labelStyle={{ width: '15%' }}>{pjtInfoItem.pjCd}</Descriptions.Item>
                            </Descriptions>

                            <Descriptions bordered column={2} size='small'>
                                <Descriptions.Item label='* 프로젝트 계약기간' labelStyle={{ width: '15%', height: '5%' }}>
                                    <Space style={{ width: '94%' }} /*프로젝트 삭제여부로 수정 20230320*/>
                                        {!pjtInfoItem.id || pjtInfoItem.id === 0 || isEditMode ?
                                            <ConfigProvider locale={locale}>
                                                <RangePicker
                                                    id='pjCtrStdt'
                                                    allowClear={false}
                                                    data-dir-name='프로젝트 계약기간' 
                                                    value={[common.isEmptyString(pjtInfoItem.pjCtrStdt) ? null : dayjs(pjtInfoItem.pjCtrStdt), common.isEmptyString(pjtInfoItem.pjCtrEndt) ? null : dayjs(pjtInfoItem.pjCtrEndt)]}
                                                    onChange={ctrCalendar_onChange}
                                                />
                                            </ConfigProvider>
                                            : commonDate.maskDate(pjtInfoItem.pjCtrStdt, 'YYYY-MM-DD') + ' ~ ' + commonDate.maskDate(pjtInfoItem.pjCtrEndt, 'YYYY-MM-DD')}
                                    </Space>
                                </Descriptions.Item>
                                <Descriptions.Item label='* 프로젝트 수행기간' labelStyle={{ width: '15%' }}>
                                    <Space style={{ width: '94%' }}>
                                        {!pjtInfoItem.id || pjtInfoItem.id === 0 || isEditMode ?
                                            <ConfigProvider locale={locale}>
                                                <RangePicker
                                                    id='pjStartDt'
                                                    allowClear={false}
                                                    data-dir-name='프로젝트 수행기간' 
                                                    value={[common.isEmptyString(pjtInfoItem.pjStartDt) ? null : dayjs(pjtInfoItem.pjStartDt), common.isEmptyString(pjtInfoItem.pjEndDt) ? null : dayjs(pjtInfoItem.pjEndDt)]}
                                                    onChange={calendar_onChange}
                                                />
                                            </ConfigProvider>
                                            : commonDate.maskDate(pjtInfoItem.pjStartDt, 'YYYY-MM-DD') + ' ~ ' + commonDate.maskDate(pjtInfoItem.pjEndDt, 'YYYY-MM-DD')}
                                    </Space>
                                </Descriptions.Item>
                                <Descriptions.Item label='* 프로젝트명' labelStyle={{ width: '15%' }}>
                                    <Input id='inputpjNm' data-dir-name='프로젝트명' name='pjNm' readOnly={pjtInfoItem.id > 0 && !isEditMode} value={pjtInfoItem.pjNm} style={{ width: '100%' }} onChange={inputOnChange} />
                                </Descriptions.Item>
                            </Descriptions>

                            <Descriptions bordered column={1} size='small'>
                                <Descriptions.Item label='* 프로젝트설명' labelStyle={{ width: '15%' }}>
                                    <TextArea id='inputpjCntnt' data-dir-name='프로젝트설명' name='pjCntnt' readOnly={pjtInfoItem.id > 0 && !isEditMode} value={pjtInfoItem.pjCntnt} autoSize={{ minRows: 2 }} style={{ width: '100%' }} onChange={inputOnChange} />
                                </Descriptions.Item>
                            </Descriptions>
                            <Descriptions bordered column={2} size='small'>
                                <Descriptions.Item label='* 고객사명' labelStyle={{ width: '15%' }}>
                                    <Space>
                                        {!pjtInfoItem.id || pjtInfoItem.id === 0 || isEditMode ?
                                        <Input id='inCusNm' data-dir-name='고객사명' name='cusNm' readOnly value={pjtInfoItem.cusNm} style={{ width: 300 }} onChange={inputOnChange} />
                                        : pjtInfoItem.cusNm
                                        }
                                        <Button     /* 돋보기 버튼 추가 */
                                            id='btnSrchCusNm'
                                            name='btnSrchCusNm'
                                            disabled={pjtInfoItem.id > 0 && !isEditMode}   // 등록or수정상태가 아닐 경우 수정 불가 
                                            className='background-color-default-button'
                                            icon={<SearchOutlined />}
                                            onClick={onClick}
                                        >
                                        </Button>
                                    </Space>

                                </Descriptions.Item>
                                <Descriptions.Item label='* Project Manager'>
                                    <Space>
                                        {!pjtInfoItem.id || pjtInfoItem.id === 0 || isEditMode ?
                                            <Select
                                                id='pmEmpNo'
                                                data-dir-name='Project Manager'
                                                disabled={common.getEmpNo() !== null && !common.isAdmin()}
                                                showSearch
                                                style={{ width: 300 }}
                                                value={pjtInfoItem.pmEmpNo}
                                                options={userOptions()}
                                                optionFilterProp='label'
                                                filterSort={(optionA: any, optionB: any) => {
                                                    const labelA = (optionA?.label ?? '').toLowerCase();
                                                    const labelB = (optionB?.label ?? '').toLowerCase();
                                                
                                                    return labelA.localeCompare(labelB);
                                                }}
                                                onChange={userSelect} >
                                            </Select>
                                            : pjtInfoItem.pmUserNm + '[' + pjtInfoItem.pmUserId + ']'
                                        }
                                        <Button
                                            id='btnSendEmailToPm'
                                            name='sendEmailToPm'
                                            className='background-color-default-button'
                                            onClick={sendEmailToPm}
                                            disabled={(!pjtInfoItem.pjCd || (common.getEmpNo() !== pjtInfoItem.pmEmpNo && !common.isAdmin()))}
                                        >
                                        메일 발송
                                        </Button>
                                    </Space>
                                </Descriptions.Item>
                                <Descriptions.Item label='사업구분' labelStyle={{ width: '15%' }}>
                                    <Select id='inWorkDcd'
                                        // data-dir-name='사업구분'
                                        style={{ width: 300 }}
                                        value={pjtInfoItem.workDcd}
                                        onChange={workDcd_onChange}
                                        options={cmbList022}
                                        // ReadOnly 적용
                                        {...common.getReadonlySelectboxProps(pjtInfoItem.id > 0 && !isEditMode)}
                                        />
                                </Descriptions.Item>
                                <Descriptions.Item label='주사업자명' labelStyle={{ width: '15%' }}>
                                    <Input id='inPjMainNm' name='pjMainNm' readOnly={pjtInfoItem.id > 0 && !isEditMode} value={pjtInfoItem.pjMainNm} style={{ width: '94%' }} onChange={inputOnChange}
                                        // data-dir-name='주사업자명'
                                    />
                                </Descriptions.Item>
                                <Descriptions.Item label='총계약금액(부가세제외)' labelStyle={{ width: '15%' }}>
                                    <Input id='inTotAmntAmt' name='totAmntAmt' maxLength={23} readOnly={pjtInfoItem.id > 0 && !isEditMode} value={pjtInfoItem.totAmntAmt} style={{ width: '94%', textAlign: 'right' }} onChange={inputNumChange}
                                        // data-dir-name='총계약금액(부가세제외)'
                                    /> 원
                                </Descriptions.Item>
                                <Descriptions.Item label='오픈예정일자' labelStyle={{ width: '15%' }}>
                                    <Space style={{ width: 305 }}>
                                        {!pjtInfoItem.id || pjtInfoItem.id === 0 || isEditMode ?
                                            <ConfigProvider locale={locale}>
                                                <DatePicker
                                                    id='inExpctOpenDt'
                                                    // data-dir-name='오픈예정일자'
                                                    name='expctOpenDt'
                                                    placeholder='오픈예정일자'
                                                    allowClear={false}
                                                    value={common.isEmptyString(pjtInfoItem.expctOpenDt) ? null : dayjs(pjtInfoItem.expctOpenDt)}
                                                    picker='date'
                                                    onChange={openCalendar_onChange}
                                                />
                                            </ConfigProvider>
                                            : commonDate.maskDate(pjtInfoItem.expctOpenDt, 'YYYY-MM-DD')}
                                    </Space>
                                </Descriptions.Item>
                                <Descriptions.Item label='계약공수' labelStyle={{ width: '15%' }}>
                                    <Input id='inCtrManMonth' name='ctrManMonth' maxLength={15} readOnly={pjtInfoItem.id > 0 && !isEditMode} value={pjtInfoItem.ctrManMonth} style={{ width: '90%', textAlign: 'right' }} onChange={inputNumChange}
                                        // data-dir-name='계약공수'
                                    /> M/M
                                </Descriptions.Item>
                                <Descriptions.Item label='수행공수' labelStyle={{ width: '15%' }}>
                                    <Input id='inPrcsManMonth'name='prcsManMonth' maxLength={15} readOnly={pjtInfoItem.id > 0 && !isEditMode} value={pjtInfoItem.prcsManMonth} style={{ width: '90%', textAlign: 'right' }} onChange={inputNumChange}
                                        // data-dir-name='수행공수' 
                                    /> M/M
                                </Descriptions.Item>
                                <Descriptions.Item label='컨설팅비용' labelStyle={{ width: '15%' }}>
                                    <Input id='inPjConsAmt' name='pjConsAmt' maxLength={23} readOnly={pjtInfoItem.id > 0 && !isEditMode} value={pjtInfoItem.pjConsAmt} style={{ width: '94%', textAlign: 'right' }} onChange={inputNumChange}
                                        // data-dir-name='컨설팅비용'
                                    /> 원
                                </Descriptions.Item>
                                <Descriptions.Item label='개발비용' labelStyle={{ width: '15%' }}>
                                    <Input id='inPjDevAmt' name='pjDevAmt' maxLength={23} readOnly={pjtInfoItem.id > 0 && !isEditMode} value={pjtInfoItem.pjDevAmt} style={{ width: '94%', textAlign: 'right' }} onChange={inputNumChange}
                                        // data-dir-name='개발비용'
                                    /> 원
                                </Descriptions.Item>
                                <Descriptions.Item label='S/W비용' labelStyle={{ width: '15%' }}>
                                    <Input id='inPjSwAmt' name='pjSwAmt' maxLength={23} readOnly={pjtInfoItem.id > 0 && !isEditMode} value={pjtInfoItem.pjSwAmt} style={{ width: '94%', textAlign: 'right' }} onChange={inputNumChange}
                                        // data-dir-name='S/W비용'
                                    /> 원
                                </Descriptions.Item>
                                <Descriptions.Item label='H/W비용' labelStyle={{ width: '15%' }}>
                                    <Input id='inPjHwAmt' name='pjHwAmt' maxLength={23} readOnly={pjtInfoItem.id > 0 && !isEditMode} value={pjtInfoItem.pjHwAmt} style={{ width: '94%', textAlign: 'right' }} onChange={inputNumChange}
                                        // data-dir-name='H/W비용'
                                    /> 원
                                </Descriptions.Item>
                            </Descriptions>
                            <Descriptions bordered column={1} size='small'>
                                <Descriptions.Item label='기타비용' labelStyle={{ width: '15%' }}>
                                    <Input id='inPjEtcAmt' name='pjEtcAmt' maxLength={23} readOnly={pjtInfoItem.id > 0 && !isEditMode} value={pjtInfoItem.pjEtcAmt} style={{ width: '97.5%', textAlign: 'right' }} onChange={inputNumChange}
                                        // data-dir-name='기타비용'
                                    /> 원
                                </Descriptions.Item>
                            </Descriptions>
                            <Descriptions bordered column={4} size='small'>
                                <Descriptions.Item label='관리부서' labelStyle={{ width: '20%' }}>
                                    {!pjtInfoItem.id || pjtInfoItem.id === 0 || isEditMode ?
                                        <Select id='inPjAmnDeptCd'
                                            // data-dir-name='관리부서'
                                            style={{ width: 200 }}
                                            value={pjtInfoItem.pjAmnDeptCd} 
                                            onChange={pjAmnDeptCd_onChange}
                                            options={cmbList024}/>
                                        : pjtInfoItem.pjAmnDeptNm
                                    }
                                </Descriptions.Item>
                                <Descriptions.Item label='관리 부서장' labelStyle={{ width: '20%' }}>
                                    {!pjtInfoItem.id || pjtInfoItem.id === 0 || isEditMode ?
                                        <Select id='inPjAmnDeptEmpNo'
                                            // data-dir-name='관리부서장'
                                            style={{ width: 195 }}
                                            value={pjtInfoItem.pjAmnDeptEmpNo}
                                            onChange={pjAmnDeptUserId_onChange}
                                            options={cmbDeptUsrList}/>
                                        : pjtInfoItem.pjAmnDeptUserNm
                                    }
                                </Descriptions.Item>
                                <Descriptions.Item label='관리실' labelStyle={{ width: '20%' }}>
                                    {!pjtInfoItem.id || pjtInfoItem.id === 0 || isEditMode ?
                                        <Select id='inPjAmnOfcDeptCd'
                                            // data-dir-name='관리실'
                                            style={{ width: 200 }}
                                            value={pjtInfoItem.pjAmnOfcDeptCd}
                                            onChange={pjAmnOfcDeptCd_onChange}
                                            options={cmbList025}/>
                                        : pjtInfoItem.pjAmnOfcDeptNm
                                    }
                                </Descriptions.Item>
                                <Descriptions.Item label='관리실장' labelStyle={{ width: '20%' }}>
                                    {!pjtInfoItem.id || pjtInfoItem.id === 0 || isEditMode ?
                                        <Select id='inPjAmnOfcEmpNo'
                                            // data-dir-name='관리실장'
                                            style={{ width: 200 }} 
                                            value={pjtInfoItem.pjAmnOfcEmpNo} 
                                            onChange={pjAmnOfcUserId_onChange}
                                            options={cmbOfcUsrList}/>
                                        : pjtInfoItem.pjAmnOfcUserNm
                                    }
                                </Descriptions.Item>
                                <Descriptions.Item label='프로젝트성격' labelStyle={{ width: '20%' }}>
                                    <Select id='inPjTypeCd' 
                                        // data-dir-name='프로젝트성격'
                                        style={{ width: 200 }}
                                        value={pjtInfoItem.pjTypeCd}
                                        onChange={pjTypeCd_onChange}
                                        options={cmbList023}
                                        // ReadOnly 적용
                                        {...common.getReadonlySelectboxProps(pjtInfoItem.id > 0 && !isEditMode)}
                                        />
                                </Descriptions.Item>
                                <Descriptions.Item label='개발유형' labelStyle={{ width: '20%' }}>
                                    <Select id='inPjDevTypeCd'
                                        // data-dir-name='개발유형'
                                        style={{ width: 195 }}
                                        value={pjtInfoItem.pjDevTypeCd}
                                        onChange={pjDevTypeCd_onChange}
                                        options={cmbList021}
                                        // ReadOnly 적용
                                        {...common.getReadonlySelectboxProps(pjtInfoItem.id > 0 && !isEditMode)}
                                        />
                                </Descriptions.Item>
                                <Descriptions.Item label='프로젝트지역' labelStyle={{ width: '20%' }}>
                                    <Input id='inPjReg' name='pjReg' readOnly={pjtInfoItem.id > 0 && !isEditMode} value={pjtInfoItem.pjReg} style={{ width: 200 }} onChange={inputOnChange}
                                        // data-dir-name='프로젝트지역'
                                    />
                                </Descriptions.Item>
                                <Descriptions.Item label='원격지여부' labelStyle={{ width: '20%' }}>
                                    {!pjtInfoItem.id || pjtInfoItem.id === 0 || isEditMode ?
                                        <Select id='inRemoteYn' style={{ width: 200 }} value={pjtInfoItem.remoteYn} onChange={rmtYn_onChange}
                                            // data-dir-name='원격지여부'
                                            // ReadOnly 적용
                                            {...common.getReadonlySelectboxProps(pjtInfoItem.id > 0 && !isEditMode)}
                                        >
                                            <option value='Y'>여</option>
                                            <option value='N'>부</option>
                                        </Select>
                                        : <Input value={pjtInfoItem.remoteYn === 'N' ? '부' : '여'} bordered={false} style={{ paddingLeft: 1, width: 200 }}></Input>
                                    }
                                </Descriptions.Item>
                            </Descriptions>
                            <Descriptions bordered column={1} size='small'>
                                <Descriptions.Item label='프로젝트 개발형식' labelStyle={{ width: '15%' }}>
                                    <Input id='inPjDevformType' name='pjDevformType' readOnly={pjtInfoItem.id > 0 && !isEditMode} value={pjtInfoItem.pjDevformType} style={{ width: '100%' }} onChange={inputOnChange}
                                        // data-dir-name='프로젝트 개발형식'
                                    />
                                </Descriptions.Item>
                            </Descriptions>
                            <Descriptions bordered column={2} size='small'>
                                <Descriptions.Item label='프로젝트 개발툴(화면)' labelStyle={{ width: '15%' }}>
                                    <Input id='inPjDevtoolView' name='pjDevtoolView' readOnly={pjtInfoItem.id > 0 && !isEditMode} value={pjtInfoItem.pjDevtoolView} style={{ width: '100%' }} onChange={inputOnChange}
                                        // data-dir-name='프로젝트 개발툴(화면)'
                                    />
                                </Descriptions.Item>
                                <Descriptions.Item label='프로젝트 개발툴(서비스)' labelStyle={{ width: '15%' }}>
                                    <Input id='inPjDevtoolSvc' name='pjDevtoolSvc' readOnly={pjtInfoItem.id > 0 && !isEditMode} value={pjtInfoItem.pjDevtoolSvc} style={{ width: '100%' }} onChange={inputOnChange}
                                        // data-dir-name='프로젝트 개발툴(서비스)'
                                    />
                                </Descriptions.Item>
                                <Descriptions.Item label='프로젝트 개발툴(DB)' labelStyle={{ width: '15%' }}>
                                    <Input id='inPjDevtoolDb' name='pjDevtoolDb' readOnly={pjtInfoItem.id > 0 && !isEditMode} value={pjtInfoItem.pjDevtoolDb} style={{ width: '100%' }} onChange={inputOnChange}
                                        // data-dir-name='프로젝트 개발툴(DB)'
                                    />
                                </Descriptions.Item>
                                <Descriptions.Item label='프로젝트 개발툴(레포트)' labelStyle={{ width: '15%' }}>
                                    <Input id='inPjDevtoolRpt' name='pjDevtoolRpt' readOnly={pjtInfoItem.id > 0 && !isEditMode} value={pjtInfoItem.pjDevtoolRpt} style={{ width: '100%' }} onChange={inputOnChange}
                                        // data-dir-name='프로젝트 개발툴(레포트)'
                                    />
                                </Descriptions.Item>
                            </Descriptions>
                            <Descriptions bordered column={1} size='small'>
                                <Descriptions.Item label='프로젝트 종료여부' labelStyle={{ width: '15%' }}>
                                    {!pjtInfoItem.id || pjtInfoItem.id === 0 || isEditMode ?
                                        <Select id='endYn' data-dir-name='프로젝트 종료여부' defaultValue='N' style={{ width: 300 }} value={pjtInfoItem.endYn} onChange={endYn_onChange}>
                                            <option value='N'>부</option>.
                                            <option value='Y'>여</option>
                                        </Select>
                                        : pjtInfoItem.endYn === 'N' ? '부' : '여'
                                    }
                                </Descriptions.Item>
                            </Descriptions>
                        </Col>
                    </Row>
                </div>

                <Row justify='center' style={{ marginTop: 15 }}>
                    <Col style={{ marginRight: 15 }}>
                        <Space size='small'>
                            <Button
                                name='btnreset'
                                className='background-color-default-button'
                                onClick={onClick}
                            >
                                초기화
                            </Button>
                            <Button
                                name='btnList'
                                className='background-color-default-button'
                                onClick={onClick}
                            >
                                목록보기
                            </Button>
                            {!(!pjtInfoItem.id || pjtInfoItem.id === 0 || isEditMode)?
                                <>
                                    <Button
                                        name='btnEdit'
                                        className='background-color-default-button'
                                        onClick={() => setIsEditMode(true)}
                                        disabled={(common.getEmpNo() !== pjtInfoItem.pmEmpNo && !common.isAdmin()) || isEditMode}
                                    >
                                        수정
                                    </Button>
                                    <Button
                                        name='btnDelete'
                                        className='background-color-default-button'
                                        onClick={(onClick)}
                                        disabled={(common.getEmpNo() !== pjtInfoItem.pmEmpNo && !common.isAdmin()) || isEditMode}
                                    >
                                        삭제
                                    </Button>
                                </>
                                : null}
                            {!pjtInfoItem.id || pjtInfoItem.id === 0 || isEditMode ?
                                <Button
                                    name='btnSave'
                                    className='background-color-primary-button'
                                    onClick={onClick}
                                    disabled={pjtInfoItem.id > 0 && !isEditMode}
                                >
                                    저장
                                </Button>
                                : null}
                        </Space>
                    </Col>
                </Row>

            </Content>
        </Layout>
    );
}

export default Pjt0102m;
